// extracted by mini-css-extract-plugin
module.exports = {"svg":"FooterLogin_svg__S4nbv"};